import { apiSlice } from 'api/apiSlice'
import { ActivePromoCodes, Promotion } from 'shared/types/Promotion'

type activatePromoCodeBody = {
  code: string
}

const promoCodeApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    activatePromoCode: build.mutation<ActivePromoCodes, activatePromoCodeBody>({
      query: (body) => ({
        app: 'sneakers',
        data: body,
        method: 'POST',
        url: `/web-api/v1/promo_codes/activate`,
      }),
    }),
    getPromotion: build.query<Promotion, number>({
      query: (id) => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/promo_codes/${id}`,
      }),
    }),
  }),
})

export const { useActivatePromoCodeMutation, useGetPromotionQuery } = promoCodeApi
